import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";
import SectionPlainTitle from "../../Common/components/SectionPlainTitle";

export default class ColumnistsLayout extends Component {
  static propTypes = {
    MoreNews: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      MoreNews,
    } = this.props;

    return (
      <div className="horse-profile-page">
        <StandardPage sport="racing" title="Columnists">
          <div className="main-layout-block">
            <SectionPlainTitle className="page-main-section-title" level={1}>Columnists</SectionPlainTitle>
          </div>
          <div className="main-layout-left-column">
            {MoreNews}
          </div>

          <RightColumn location={location}
                       sport="racing"
                       content={
                         ["mostReadAll", "topMpu", "ocWidget", "racingTips", "horseRacingNextRaceOff", "footballTips"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/News/containers/ColumnistsLayout.js